export type TextEmojiSegment = {
  kind: 'text' | 'emoji'
  value: string
}

function isEmojiGrapheme(grapheme: string): boolean {
  return /\p{Extended_Pictographic}/u.test(grapheme)
}

/** Split a string so emoji graphemes can skip gradient / color styling. */
export function splitTextEmojiSegments(text: string): TextEmojiSegment[] {
  if (!text) return [{ kind: 'text', value: '' }]

  const segmenter = new Intl.Segmenter(undefined, { granularity: 'grapheme' })
  const parts: TextEmojiSegment[] = []

  let currentKind: TextEmojiSegment['kind'] | null = null
  let currentValue = ''

  for (const { segment } of segmenter.segment(text)) {
    const kind = isEmojiGrapheme(segment) ? 'emoji' : 'text'
    if (currentKind === kind) {
      currentValue += segment
    } else {
      if (currentKind) {
        parts.push({ kind: currentKind, value: currentValue })
      }
      currentKind = kind
      currentValue = segment
    }
  }

  if (currentKind) {
    parts.push({ kind: currentKind, value: currentValue })
  }

  return parts.length > 0 ? parts : [{ kind: 'text', value: text }]
}
